import { useMemo } from 'react';
import { Footer } from '@telus-alberta-health-web/shared-module';
import { ParagraphText } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useIsBelowTablet } from '@telus-alberta-health-web/shared-module/src/hooks/use-is-below-tablet/use-is-below-tablet.hook';
import { useLocation } from 'react-router-dom';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { useAppFooterLinks } from './use-app-footer-links.hook';

// Hide footer on specific routes like activity page because we want full screen experience with no scrolling
const hideFooterRoutes = [
  `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/activity`,
];

export const AppFooter = () => {
  const { footerLinks, appDownloadLinks } = useAppFooterLinks();
  const { formatMessage } = useIntl();
  const currentYear = new Date().getFullYear();
  const isBelowTablet = useIsBelowTablet();
  const location = useLocation();

  const shouldHideFooter = useMemo(
    () => hideFooterRoutes.some((route) => location.pathname.startsWith(route)),
    [location.pathname],
  );

  if (shouldHideFooter) {
    return null;
  }

  const footerDescription = (
    <>
      <ParagraphText
        size="xs"
        css={{
          color: '$onSurfaceTextPrimary',
          typography: '$caption',
        }}
      >
        {formatMessage({ id: 'STR_FOOTER_DESCRIPTION' })}
      </ParagraphText>

      <ParagraphText
        size="xs"
        css={{
          color: '$onSurfaceTextPrimary',
          typography: '$label',
          marginBlockStart: isBelowTablet ? '$one' : '$none',
        }}
      >
        {formatMessage({ id: 'STR_FOOTER_COPYRIGHT' }, { year: currentYear })}
      </ParagraphText>
    </>
  );
  return (
    <Footer
      footerDescription={footerDescription}
      footerLinks={footerLinks}
      footerAppDownloadAssets={appDownloadLinks}
      backgroundColor="$surfaceBackgroundTertiary"
    />
  );
};
